// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-flex-box {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}

.modal-header-style {
  padding: 2rem;
  padding-bottom: 0;
}

.modal-title-style {
  order: 2;
  margin: 0;
  padding: 12px;
  font-weight: 700;
  font-size: 30px;
  color: #12394d;
  display: inline-block;
}

.modal-close-style {
  order: 1;
  margin-left: auto;
  border: none;
  background: transparent;
  font-size: 1.5rem;
  margin-right: 1rem;
  flex-grow: 0;
}

.line-style {
  margin-right: 5px;
  margin-left: 4rem;
  margin-top: 5px;
  margin-bottom: 0;
  height: 0px;
  max-width: 75px;
  background-color: #d9d9d9;
  border: 2px solid #555;
}

.heading-style {
  font-size: 1.2rem;
  padding-left: 1rem;
}

.active-button {
  border: 2px solid #cc0000;
  display: flex;
  padding: 6px 16px;
  align-items: center;
  gap: 8px;
  background-color: #cc0000;
  color: white;
}

.inactive-button {
  border: 2px solid gray;
  display: flex;
  padding: 6px 16px;
  align-items: center;
  gap: 8px;
  background-color: white;
  color: gray;
}

.inactive-button-left {
  border: 2px solid gray;
  display: flex;
  padding: 6px 16px;
  align-items: center;
  gap: 8px;
  background-color: white;
  color: gray;
}

.graph-div-style {
  margin-bottom: 0;
  overflow-x: scroll;
  display: flex;
  justify-content: center;
}

.label-style {
  font-family: "Roboto Bold";
  color: #333;
  font-size: 1.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles-arabic/analytics.rtl.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,iBAAiB;AACnB","sourcesContent":[".modal-flex-box {\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n}\n\n.modal-header-style {\n  padding: 2rem;\n  padding-bottom: 0;\n}\n\n.modal-title-style {\n  order: 2;\n  margin: 0;\n  padding: 12px;\n  font-weight: 700;\n  font-size: 30px;\n  color: #12394d;\n  display: inline-block;\n}\n\n.modal-close-style {\n  order: 1;\n  margin-left: auto;\n  border: none;\n  background: transparent;\n  font-size: 1.5rem;\n  margin-right: 1rem;\n  flex-grow: 0;\n}\n\n.line-style {\n  margin-right: 5px;\n  margin-left: 4rem;\n  margin-top: 5px;\n  margin-bottom: 0;\n  height: 0px;\n  max-width: 75px;\n  background-color: #d9d9d9;\n  border: 2px solid #555;\n}\n\n.heading-style {\n  font-size: 1.2rem;\n  padding-left: 1rem;\n}\n\n.active-button {\n  border: 2px solid #cc0000;\n  display: flex;\n  padding: 6px 16px;\n  align-items: center;\n  gap: 8px;\n  background-color: #cc0000;\n  color: white;\n}\n\n.inactive-button {\n  border: 2px solid gray;\n  display: flex;\n  padding: 6px 16px;\n  align-items: center;\n  gap: 8px;\n  background-color: white;\n  color: gray;\n}\n\n.inactive-button-left {\n  border: 2px solid gray;\n  display: flex;\n  padding: 6px 16px;\n  align-items: center;\n  gap: 8px;\n  background-color: white;\n  color: gray;\n}\n\n.graph-div-style {\n  margin-bottom: 0;\n  overflow-x: scroll;\n  display: flex;\n  justify-content: center;\n}\n\n.label-style {\n  font-family: \"Roboto Bold\";\n  color: #333;\n  font-size: 1.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
